module.exports = __webpack_public_path__ + "img/logo.366f704a.png";